import Admin from "@/model/adminUser";
import { VuexModule, Module, Action, Mutation } from "vuex-module-decorators";
import PaginateModel from "@/model/paginate";
import adminApi from "@/api/adminApi";

@Module({ namespaced: true })
export default class AdminModule extends VuexModule {
  admins: Admin[] = [];
  paginate: PaginateModel;

  @Mutation
  setAdmins(admins: Admin[]): void {
    this.admins = admins;
  }

  @Mutation
  setPaginate(paginate: PaginateModel): void {
    this.paginate = paginate;
  }

  @Action({ rawError: true })
  async fetchAdminList(query: any): Promise<void> {
    const { list, paginate } = await adminApi.getAllUsers(query);
    this.context.commit("setAdmins", list);
    this.context.commit("setPaginate", paginate);
  }

  get getAdmins(): Admin[] {
    return this.admins;
  }

  get getPaginate(): PaginateModel {
    return this.paginate;
  }
}
